
        // ===== Intelligence Packet Panel =====
        // The analyst-curated context for a subject — known threat actors,
        // historic incidents, close associates (minimal data), behavioural
        // patterns, client priorities, plus a free-text addendum.
        //
        // This data feeds into every LLM call about the subject, making
        // assessments and narratives subject-specific rather than generic.

        // Suggestion chips — analyst clicks to add a pre-filled starter
        // item, then edits to make it specific to this subject. These are
        // prompts, not constraints.
        const BEHAVIOURAL_PATTERN_CHIPS = [
            "Posts location in real time",
            "Publishes work / travel schedule publicly",
            "Lives at the registered business address",
            "Responds to provocation publicly",
            "Drives a recognisable vehicle",
            "Has regular venues (gym, café, club)",
            "Travel announced in advance",
            "Family members named publicly",
            "Personal mobile or email widely known",
        ];

export { BEHAVIOURAL_PATTERN_CHIPS };
